module.exports = __webpack_public_path__ + "img/Reporte-Eventos.969ec449.png";